import type { MagentoProductTypeName, MagentoStockStatus } from "@jti/magento-types";

type StockStatusVariant = {
  product: { sku: string; stock_status: string };
};

type StockStatusProductData = {
  __typename?: MagentoProductTypeName | string;
  stock_status?: MagentoStockStatus | string;
  variants?: StockStatusVariant[];
};

const getConfigurableProductStockStatus = (
  variants: StockStatusVariant[] | undefined,
  currentVariantSku: string
): MagentoStockStatus => {
  const variant = variants?.find(({ product }) => product.sku === currentVariantSku);

  return (variant?.product.stock_status as MagentoStockStatus) ?? "OUT_OF_STOCK";
};

export const getStockStatus = (currentVariantSku: string, data?: StockStatusProductData): MagentoStockStatus => {
  const { __typename = "", stock_status = "", variants } = data ?? {};

  if ((__typename as MagentoProductTypeName) === "ConfigurableProduct") {
    return getConfigurableProductStockStatus(variants, currentVariantSku);
  }

  return (stock_status as MagentoStockStatus) || "OUT_OF_STOCK";
};
